import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import CModal from '@/components/CModal.vue';
import CInput from '@/components/shared/CInput';
import CButton from '@/components/shared/CButton';

interface Emits {
    (event: 'input', value: boolean): void;
    (event: 'save', data: { id: number; value: string }): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomMapStyleModal',
  props: {
    value: { type: Boolean },
    styleId: { default: '' },
    editIndex: null
  },
  emits: ["input", "save"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'save', data: { id: number; value: string }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, styleId: string, editIndex?: number };

const MAP_BOX_PREFIX = 'mapbox://styles/';




const inputValue = ref('');

const isOpen = ref(props.value);

watch(
    () => props.value,
    (val) => {
        isOpen.value = val;
        if (val && props.styleId) {
            inputValue.value = `${MAP_BOX_PREFIX}${props.styleId}`;
        }
    }
);

const handleCancel = () => {
    inputValue.value = '';
    emit('input', false);
};

const handleSave = () => {
    if (props.editIndex == null) return;

    emit('save', {
        id: props.editIndex,
        value: inputValue.value.replace(MAP_BOX_PREFIX, '')
    });
    emit('input', false);
};

return { __sfc: true,MAP_BOX_PREFIX, props, emit, inputValue, isOpen, handleCancel, handleSave, CModal, CInput, CButton }
}

})